/**
 * @fileoverview Validation functions for solarIQ - mainly deal with validating user input format.
 * return boolean true/false only
 * note: toast displayed to user on false result
 */

/**
 * isValidPhone:
 * validates user input phone numbers based on South African cell number format (through regex checks).
 * accepts formats: +27XXXXXXXXX, 0XXXXXXXXX
 * accounts for spaces " " in input
 * accepted mobile prefixes: 06X, 07X, 08X
 * @param {string} val - input to validate (must be non-null string)
 * @returns {boolean} - True if valid ZA number
 */

/////////////////////////
// CHECK: expand to allow more number formats or prefixes in the case of foreign numbers?
/////////////////////////

export function isValidPhone(val) {
    const stripped = val.replace(/[\s\-()]/g, "");
    return  /^(\+27|0)[6-8][0-9]{8}$/.test(stripped);
}

/**
 * isValidEmail:
 * validates user input email address format through regex checks
 * RFC compliant check so not exhaustive.
 * 
 * @param {string} val - input to validate (must be non-null string)
 * @returns {boolean} - True if valid email address format
*/
export function isValidEmail(val) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(val.trim());
}